const pb23GridBannersV2 = {
    init()
    {
	}
}

window.initializeComponent.push({ component: "pb23-grid--banners-v2", init: pb23GridBannersV2.init });

export default() => {
    pb23GridBannersV2.init();
}